<template>
    <!-- sun -->
    <svg xmlns="http://www.w3.org/2000/svg" v-if="isDarkMode" class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>

    <!-- moon -->
     <svg xmlns="http://www.w3.org/2000/svg" v-else class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>

</template>
<script>
export default {
    data(){
        return{
            isDarkMode: true
        }
    },
    mounted(){
        let savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark') {
            this.isDarkMode = true;
        }else{
            this.isDarkMode = false;
        }
    },
    methods:{
        toggleThemeIcon(){     
            if(this.isDarkMode){
                 this.isDarkMode = false;
            }else{
                  this.isDarkMode = true;
            }      
        }
    }
}
</script>
<style scoped>
.icon{
    stroke: currentColor
}
    
</style>